import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Table } from 'semantic-ui-react';
import moment from 'moment';

import { AppState } from 'services/types';
import AlignLeftAndRight from 'components/AlignLeftAndRight';

// @ts-ignore
import { makeSelectQuantitySchedulesTotalForDate } from './selectors';

interface OwnProps {
    date?: string;
}

interface ConnectedProps {
    quantitySchedulesTotalForDate: number;
}

type Props = OwnProps & ConnectedProps;

export class EventsTimelineHeadCell extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { date, quantitySchedulesTotalForDate } = this.props;

        return (
            <Table.HeaderCell className="EventsTimelineHead">
                <AlignLeftAndRight
                    left={moment(date, 'YYYY-MM-DD')
                        .format('dd D')
                        .toUpperCase()}
                    right={quantitySchedulesTotalForDate.toLocaleString()}
                />
            </Table.HeaderCell>
        );
    }
}
const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    quantitySchedulesTotalForDate: makeSelectQuantitySchedulesTotalForDate()
});

export default connect(mapStateToProps)(EventsTimelineHeadCell);
